/* ============================================================
   /collections/all — client-side category/character filtering,
   filter-drawer behavior, result count.

   Scope, deliberately: Availability, Price, and Sort are real native
   Shopify inputs inside the <form id="sn-shop-filterform"> — submitting
   that form with this script absent entirely still filters/sorts
   correctly via a normal page reload. This file enhances the two
   facets Shopify has no data for yet (Category, Character) with
   instant client-side show/hide instead of a reload, since there's no
   server-side filter backing them to reload for. The one exception is
   Sort: changing it auto-submits the same real form (still a genuine
   page reload with real sort_by in the URL, not a fake client-side
   reorder) rather than requiring a separate Apply click, since Sort
   sits outside the filter drawer as its own always-visible control.
   See the architecture comment at the top of collection.liquid.
   ============================================================ */
(function () {
  var root = document.querySelector('.sn-shop');
  if (!root) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // --sn-header-h is now measured sitewide, in schnerds.js
  // (initHeaderHeightVar) — every page needs it for anchor targets
  // like #quiz, not just this one, so it moved out of this file.

  var sortSelect = root.querySelector('.sn-shop-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortSelect.form.requestSubmit();
    });
  }

  // Strip empty price inputs before the real GET submission serializes
  // them — an empty text input still contributes name= (blank) to the
  // query string otherwise, which is where the stray
  // &filter.v.price.gte=&filter.v.price.lte= came from. Disabling a
  // field is what excludes it from form serialization; nothing to
  // re-enable after, since a GET submit always navigates the page away
  // (a fresh load re-renders every field enabled from scratch).
  // Runs for every path that submits this form — the Apply button,
  // Enter key, and the sort auto-submit above, since requestSubmit()
  // dispatches the same real submit event.
  var filterForm = document.getElementById('sn-shop-filterform');
  if (filterForm) {
    filterForm.addEventListener('submit', function () {
      Array.prototype.slice.call(filterForm.querySelectorAll('input[type="number"], input[type="text"]')).forEach(function (input) {
        if (input.value.trim() === '') input.disabled = true;
      });
      // Category/Character live only in history.replaceState, not as
      // real form fields — without this, submitting Sort/Availability/
      // Price (a real navigation built from just this form's fields)
      // would silently drop whatever category/character chip was
      // active. Mirror the current state into hidden inputs so a
      // native submission carries them forward too. (state is defined
      // further down this same file — safe here since this callback
      // only ever runs later, on an actual submit event.)
      ['category', 'character'].forEach(function (key) {
        var value = key === 'category' ? state.cat : state.char;
        var existing = filterForm.querySelector('input[name="' + key + '"]');
        if (value === 'all') {
          if (existing) existing.disabled = true;
          return;
        }
        if (!existing) {
          existing = document.createElement('input');
          existing.type = 'hidden';
          existing.name = key;
          filterForm.appendChild(existing);
        }
        existing.disabled = false;
        existing.value = value;
      });
    });
  }

  // .sn-shop-card[data-chars], not a bare [data-chars] — the Aarg
  // editorial module also carries data-chars="aarg" (so a character
  // filter can hide it too), and a live check found the bare selector
  // was counting it as a 27th "card," one more than the 26 real
  // .sn-shop-card elements — exactly why the count read "27 products"
  // over a 26-card grid even after the server-side total was fixed.
  var cards = Array.prototype.slice.call(root.querySelectorAll('.sn-shop-card[data-chars]'));
  // Non-card elements that still respond to the character filter (just
  // Aarg's editorial module today) — hidden/shown by the same match
  // logic as real cards, but never counted as one.
  var charFilterExtras = Array.prototype.slice.call(root.querySelectorAll('[data-chars]:not(.sn-shop-card)'));
  var catChips = Array.prototype.slice.call(root.querySelectorAll('.sn-shop-cat-chip'));
  var charChips = Array.prototype.slice.call(root.querySelectorAll('.sn-shop-char-chip'));
  var countEl = document.getElementById('sn-shop-resultcount');
  var panelCountEl = document.getElementById('sn-shop-filter-panel-count');
  var catActiveChip = document.getElementById('sn-shop-activechip-cat');
  var charActiveChip = document.getElementById('sn-shop-activechip-char');
  var grid = document.getElementById('sn-shop-grid');
  // Fixed at a DOM position among the unfiltered products (see
  // collection.liquid) — hidden whenever a chip narrows the grid, so
  // they don't land mid-way through a short filtered result.
  var editorials = Array.prototype.slice.call(root.querySelectorAll('[data-editorial="grid"]'));

  var state = { cat: 'all', char: 'all' };

  // ---- Load More (mobile only — see .sn-shop-loadmore CSS) ----
  // Every card is already server-rendered; this only limits how many
  // stay visible at once on narrow screens. Resets to the initial
  // count whenever the filter/character state changes, same as a real
  // paginated view resets to page 1 on a new filter — "Filtering
  // resets or reconciles the loaded count correctly."
  var INITIAL_LOAD = 14;
  var MOBILE_MAX = 700;
  var loadLimit = INITIAL_LOAD;
  var loadMoreBtn = document.getElementById('sn-shop-loadmore');

  function isMobileWidth() { return window.innerWidth <= MOBILE_MAX; }

  // data-label first — category chips carry a decorative emoji inside
  // an aria-hidden span, which textContent picks up too (aria-hidden
  // only affects the accessibility tree, not the DOM text). Without
  // this, the active-filter pill on the results row would read
  // "Category: 🧸 Plush" instead of "Category: Plush".
  function labelFor(chip) { return (chip.dataset.label || chip.textContent).trim(); }

  function applyFilters(opts) {
    opts = opts || {};
    if (opts.resetLoadMore !== false) loadLimit = INITIAL_LOAD;
    var mobile = isMobileWidth();
    var matching = 0, shown = 0;
    cards.forEach(function (card) {
      var cardCat = card.dataset.category || '';
      var cardChars = (card.dataset.chars || '').trim().split(/\s+/);
      var matchesCat = state.cat === 'all' || cardCat === state.cat;
      var matchesChar = state.char === 'all' || cardChars.indexOf(state.char) !== -1;
      var matches = matchesCat && matchesChar;
      if (matches) matching += 1;
      var withinLoadLimit = !mobile || !matches || matching <= loadLimit;
      card.classList.toggle('sn-shop-card-hidden', !matches);
      card.classList.toggle('sn-shop-card-loadmore-hidden', matches && !withinLoadLimit);
      if (matches && withinLoadLimit) shown += 1;
    });

    // Same category+character match rule as real cards (Aarg's
    // editorial has no data-category, so any category filter besides
    // "Everything" hides it, matching its prior behavior exactly), no
    // load-more or counting involvement — it isn't a product.
    charFilterExtras.forEach(function (el) {
      var elCat = el.dataset.category || '';
      var elChars = (el.dataset.chars || '').trim().split(/\s+/);
      var matchesCat = state.cat === 'all' || elCat === state.cat;
      var matchesChar = state.char === 'all' || elChars.indexOf(state.char) !== -1;
      el.classList.toggle('sn-shop-card-hidden', !(matchesCat && matchesChar));
    });

    var filtering = state.cat !== 'all' || state.char !== 'all';
    editorials.forEach(function (el) { el.hidden = filtering; });

    // Result count reflects what's ACTUALLY rendered right now (post
    // category/character filter AND post load-more limit), "of" the
    // total currently matching every active filter — an appropriately
    // restrained aria-live region, one update per action, not a stream.
    // Short form ("27 products") whenever everything matching is
    // already shown; the longer "Showing X of Y" form only earns its
    // keep when there's a genuine gap between the two (mobile, before
    // Load More).
    if (countEl) {
      var noun = 'product' + (matching === 1 ? '' : 's');
      countEl.textContent = shown < matching
        ? 'Showing ' + shown + ' of ' + matching + ' ' + noun
        : matching + ' ' + noun;
      // Mirror into the filter panel's own count next to Apply Filters —
      // same text, aria-hidden there since countEl's aria-live already
      // announces the change once.
      if (panelCountEl) panelCountEl.textContent = countEl.textContent;
    }

    if (loadMoreBtn) loadMoreBtn.hidden = !mobile || shown >= matching;

    // Client-side empty state (separate from the server-rendered one,
    // which only fires when Availability/Price leave zero products —
    // this fires when Category/Character narrow everything out).
    var clientEmpty = document.getElementById('sn-shop-client-empty');
    if (clientEmpty) clientEmpty.hidden = matching !== 0;
    if (grid) grid.hidden = matching === 0 && !!clientEmpty;

    // Active-filter chips for the two client-side facets.
    if (catActiveChip) {
      catActiveChip.hidden = state.cat === 'all';
      var catText = catActiveChip.querySelector('.sn-shop-activechip-text');
      if (catText) catText.textContent = 'Category: ' + (opts.catLabel || state.cat);
    }
    if (charActiveChip) {
      charActiveChip.hidden = state.char === 'all';
      var charText = charActiveChip.querySelector('.sn-shop-activechip-text');
      if (charText) charText.textContent = 'Character: ' + (opts.charLabel || state.char);
    }

    // Bookmarkable, but not a history entry per click — see file header.
    if (!opts.skipUrlSync) {
      var url = new URL(window.location.href);
      if (state.cat === 'all') url.searchParams.delete('category'); else url.searchParams.set('category', state.cat);
      if (state.char === 'all') url.searchParams.delete('character'); else url.searchParams.set('character', state.char);
      window.history.replaceState(window.history.state, '', url);
    }
  }

  function setActiveChip(list, chip) {
    list.forEach(function (c) {
      var active = c === chip;
      c.classList.toggle('is-active', active);
      c.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  catChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      state.cat = chip.dataset.cat;
      setActiveChip(catChips, chip);
      applyFilters({ catLabel: labelFor(chip) });
    });
  });

  charChips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      state.char = chip.dataset.char;
      setActiveChip(charChips, chip);
      applyFilters({ charLabel: labelFor(chip) });
    });
  });

  // Removing a client-side active-filter chip resets that facet to "all".
  if (catActiveChip) {
    catActiveChip.querySelector('button').addEventListener('click', function () {
      var allChip = catChips[0];
      if (allChip) allChip.click();
    });
  }
  if (charActiveChip) {
    charActiveChip.querySelector('button').addEventListener('click', function () {
      var allChip = charChips[0];
      if (allChip) allChip.click();
    });
  }

  // The Learn editorial module's "See classroom supplies" link jumps
  // back to the grid AND applies the Learn category chip.
  root.querySelectorAll('[data-cat-link]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var wanted = link.dataset.catLink;
      var chip = catChips.filter(function (c) { return c.dataset.cat === wanted; })[0];
      if (chip) { e.preventDefault(); chip.click(); document.getElementById('sn-shop-toolbar').scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
    });
  });

  // Restore state from a bookmarked/shared URL on load.
  (function restoreFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var cat = params.get('category');
    var char = params.get('character');
    if (cat) {
      var catChip = catChips.filter(function (c) { return c.dataset.cat === cat; })[0];
      if (catChip) { state.cat = cat; setActiveChip(catChips, catChip); }
    }
    if (char) {
      var charChip = charChips.filter(function (c) { return c.dataset.char === char; })[0];
      if (charChip) { state.char = char; setActiveChip(charChips, charChip); }
    }
    applyFilters({ skipUrlSync: true });
  })();

  // "Load more" reveals the next batch without resetting scroll or
  // moving focus unexpectedly — focus stays on the button itself
  // (still in the DOM, in the same place) after the reveal.
  // One click reveals everything remaining in the current filtered
  // set (not a second, smaller batch) — "Showing 27 of 27" and the
  // button gone, in a single step.
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      loadLimit = cards.length;
      applyFilters({ resetLoadMore: false, skipUrlSync: true });
    });
  }

  // Crossing the mobile breakpoint changes what Load More even means —
  // re-run once on resize so the button/hidden-card state stays correct
  // rather than getting stuck in whichever state it started in.
  var lastMobileState = isMobileWidth();
  window.addEventListener('resize', function () {
    var nowMobile = isMobileWidth();
    if (nowMobile !== lastMobileState) {
      lastMobileState = nowMobile;
      applyFilters({ resetLoadMore: false, skipUrlSync: true });
    }
  });

  /* ---- Filter dropdown: inline disclosure, not a modal ---- */
  // The panel pushes the rest of the page down in normal flow (see the
  // CSS comment on .sn-shop-filter-panel) rather than covering it, so
  // the rest of the page stays fully interactive while it's open —
  // no scroll lock, no inert-ing the header/toolbar, no focus trap.
  // Only the panel itself gets inert + aria-hidden while collapsed.
  var toggle = document.getElementById('sn-shop-filter-toggle');
  var panel = document.getElementById('sn-shop-filter-panel');
  var closeBtn = document.getElementById('sn-shop-filter-close');
  if (toggle && panel) {
    var lastFocused = null;

    function focusableIn(el) {
      // getClientRects().length filters out anything not actually
      // rendered — a live check found the selector-only version could
      // hand back a hidden element as "first focusable" and silently
      // fail to move focus at all, since .focus() on a display:none
      // (or grid-template-rows:0fr-collapsed) element is a no-op.
      return Array.prototype.slice.call(
        el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (node) { return node.getClientRects().length > 0; });
    }

    function openPanel() {
      lastFocused = document.activeElement;
      panel.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      // Un-hide the panel itself BEFORE focusing into it — inert still
      // blocks focus even after removal takes effect on the same tick
      // in some engines, so order matters here.
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      var focusables = focusableIn(panel);
      if (focusables[0]) focusables[0].focus();
    }

    function closePanel() {
      panel.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      // Focus must leave the panel BEFORE it goes inert/aria-hidden —
      // hiding an element that still contains focus is invalid and
      // browsers handle it inconsistently (some force-blur to <body>,
      // losing the restore-to-toggle behavior entirely).
      if (lastFocused) lastFocused.focus();
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
    }

    // Represent "closed" only once JS is confirmed running — see the
    // comment on the panel's markup for why this isn't server-rendered.
    panel.inert = true;
    panel.setAttribute('aria-hidden', 'true');

    function isOpen() { return panel.classList.contains('is-open'); }

    toggle.addEventListener('click', function () { isOpen() ? closePanel() : openPanel(); });
    if (closeBtn) closeBtn.addEventListener('click', closePanel);

    // Escape closes it, same as any disclosure widget — no Tab focus
    // trap, since this isn't a modal and the rest of the page is meant
    // to stay reachable while it's open.
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });
  }

})();
